import { Link } from 'react-router-dom'

interface CTAPageLayoutProps {
  cta_title: string
  description: string,
  quote_link: string
}

const CallToActionLayout = ({
  cta_title,
  description,
  quote_link
}: CTAPageLayoutProps) => {
  return (
    <div>
      <section className="section-padding bg-primary-green text-white">
        <div className="container-custom text-center">
          <h2 className="mb-6 text-white">{cta_title}</h2>
          <p className="text-xl mb-8 text-green-100 max-w-2xl mx-auto">
            {description}
          </p>
          
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <Link
              to={quote_link}
              className="bg-white text-primary-green hover:bg-gray-100 font-medium px-8 py-4 rounded-lg transition-all duration-200 text-lg"
            >
              Get a Free Quotation
            </Link>
          </div>
        </div>
      </section>
    </div>
  )
}

export default CallToActionLayout